const angular = require('angular');
var app = angular.module('learn-controllers');

/**
 * Overview Content Controller
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.controller('overviewWorkshopsController', ['Application', 'Authorization', 'Workshops', 'AccessHelper', function (Application, Authorization, Workshops, AccessHelper) {
  var self = this;
  self.circleStats = {};

  self.contentCurrentTab = '';

  self.tabAccessed = {};

  self.changeTab = function(tab) {
    self.tabAccessed[tab] = true;
    self.contentCurrentTab = tab;
  };

  self.tabAccess = {
    workshops_create: AccessHelper.isAllowed(['admin', 'content', 'all_create'], [
      ['admin', 'content', 'workshops_create'],
    ], ['admin', 'creator', 'collaborator']),
    workshops: AccessHelper.isAllowed(['admin', 'content', 'all_create'], [
      ['admin', 'content', 'all_edit'],
      ['admin', 'content', 'workshops_create'],
      ['admin', 'content', 'workshops_edit'],
      ['admin', 'content', 'workshops_analytics']
    ], ['admin', 'creator', 'collaborator']),
  };  
  if (!self.tabAccess.workshops_create && !self.tabAccess.workshops) {
    Application.navigation.goTo('/explore');
    return;
  }
  self.tabAccess.archived = self.tabAccess.workshops && AccessHelper.isAllowed(['admin', 'content', 'unarchive_content'], null, ['admin']);
  if (self.tabAccess.workshops) {
    self.tabAccessed.workshops = true;
    self.contentCurrentTab = 'workshops';
  }

  self.isCollaborator = function() {
    return Authorization.isCollaborator();
  };

  Workshops.overviewStats().$promise
  .then(function(results) {
    self.circleStats = results;
  }).catch(function(error) {
    console.log('error in stats: ', error);
  });

}]);